export default __webpack_public_path__ + "static/oxygen-logo-3e008f77a49b40e7a3e1dae26af470b1.png";